import { ThemePaths, theme } from "../theme";

/**
 * Gets the current theme path from env vars and validates it exists
 * @returns A valid ThemePath that exists in the theme object
 */
export function getThemePath(): ThemePaths {
  const envTheme = process.env.REACT_APP_THEME || "default";

  // Validate that the theme path from env exists in our theme object
  // This prevents runtime errors when accessing undefined theme paths
  if (envTheme in theme) {
    return envTheme as ThemePaths;
  }

  // Fallback to default theme if env theme doesn't exist
  console.warn(`Theme '${envTheme}' not found, using default theme instead`);
  return "default";
}

/**
 * React hook that provides the current theme path
 * @returns A valid ThemePath that exists in the theme object
 */
const useGetThemePath = (): ThemePaths => {
  return getThemePath();
};
export default useGetThemePath;
